module.exports = __webpack_public_path__ + "img/arrow-right.6d4c7910.svg";